import { selectize } from '@selectize/selectize'
import { Fancybox } from '@fancyapps/ui'
import { searchSpinner, updateQueryStringParameter, getRexDocuments } from './custom-functions.js'

// selectize all select elements with default settings.
window.selectizeTheWorld = () => {

    jQuery('select:not(".unselectized")').selectize({
        plugins: ['remove_button', 'restore_on_backspace', 'clear_button', 'auto_position'],
        delimiter: ',',
        persist: false,
        create: function (input) {
            return {
                value: input, text: input,
            }
        },
    })
}

// Update the sort order when clicked.
window.changePropertySortOrder = () => {

	const sortOrder = document.getElementById( 'epl-sort-listings-' );

	if ( sortOrder ) {
		jQuery( '#epl-sort-listings-' ).selectize({
			onChange: function( value, isOnInitialize ) {
				if ( value !== '' ) {
					let url = window.location.href;
					let newUrl = updateQueryStringParameter(url, 'sortby', value );
					window.location.replace( newUrl );
				}
			}
		});
	}
}

/**
 * Once the page loads, do our stuff!
 */
document.addEventListener('DOMContentLoaded', function () {

    // Fix for the sort order tool from EPL on property archive pages.
    changePropertySortOrder();

    // Check for submit buttons and add spinner.
    searchSpinner();

    // Enables Selectize on all select elements.
    selectizeTheWorld();

    // Get Fancybox going.
    Fancybox.bind('[data-fancybox]', {})

    // Enable Tooltips for BootStrap 5.3.
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    tooltipTriggerList.forEach(tooltipTriggerEl => new understrap.Tooltip(tooltipTriggerEl))

    // Get the contract link element, and if it exists, load the data when the dropdown is clicked.
    const documentLinks = document.getElementById('contract-links');
    if (documentLinks) {
        documentLinks.addEventListener('show.bs.dropdown', event => {
            getRexDocuments(documentLinks.dataset.id)
        });
    }

    //Floating form
    var input = document.querySelector('.floating-form .form-control');

    function checkInput() {
        if (input) {
            var label = input.closest('.gfield').querySelector('.form-label');
            if (input.value !== '' || input === document.activeElement) {
                label.classList.add('float-label');
            } else {
                label.classList.remove('float-label');
            }
        }
    }

    if (input) {
        input.addEventListener('focus', checkInput);
        input.addEventListener('blur', checkInput);
        input.addEventListener('input', checkInput);
    }

    // Initial check
    checkInput();

    function test() {
        return $.ajax({ // <----- Notice the return statement here
            url: url,
            type: 'GET',
            success: {
                if(input) {
                    checkInput();
                    input.addEventListener('focus', checkInput);
                    input.addEventListener('blur', checkInput);
                    input.addEventListener('input', checkInput);
                }
            }
        });
    }

});

jQuery(document).ready(function($) {
	var inc = 0;
	if ($('#property_location_main')){
		$('#property_location_main').selectize({
			plugins: ['remove_button', 'restore_on_backspace', 'auto_position'],
			onChange: function(value) {
				copySelectizeOptions(value, $('#property_location_main'), $('#property_location') );
			}
		});

	}
	if ($('#property_location')){
		$('#property_location').selectize({
			plugins: ['remove_button', 'restore_on_backspace', 'auto_position'],
			onChange: function(value) {
				copySelectizeOptions(value, $('#property_location'), $('#property_location_main') );
			}
		});
	}

	function copySelectizeOptions(value, source, destination) {
		var $sourceSelect = source.selectize();
		var sourceSelectize = $sourceSelect[0].selectize;
		var selectedValues = sourceSelectize.getValue();

		var $destinationSelect = destination.selectize();
		var destinationSelectize = $destinationSelect[0].selectize;
		destinationSelectize.clear();

		selectedValues.forEach(function(value) {
			var option = sourceSelectize.getOption(value);
			destinationSelectize.addOption(option, true);
			destinationSelectize.addItem(value, true);
			sourceSelectize.addOption(option, true);
			sourceSelectize.addItem(value, true);
		});
	}
});